import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close1",
  "use": "icon-close1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close1\">\n<g id=\"icon-close1_&#229;&#133;&#179;&#233;&#151;&#173;\">\n<g id=\"icon-close1_Group 3747\">\n<rect id=\"icon-close1_Rectangle 908\" x=\"5.41406\" y=\"4\" width=\"20\" height=\"2\" transform=\"rotate(45 5.41406 4)\" />\n<rect id=\"icon-close1_Rectangle 909\" width=\"20\" height=\"2\" transform=\"matrix(-0.707107 0.707107 0.707107 0.707107 18.1421 4)\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol